import moment from 'moment';

export default function addDaysMonthsYearsToDate(date, duree) {
  return moment(date)
    .add(duree.days, 'd')
    .add(duree.months, 'M')
    .add(duree.years, 'y');
}
